// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3UQMK","header":"MessagesList_header__2VZcI","chat":"MessagesList_chat__1oXMs"};